module.exports = __webpack_public_path__ + "img/national-bank.040d1953.png";